import * as React from 'react';

const ComingSoon: React.FC = () => {
  const arrow = 'absolute text-[#5B5B5B] h-4 w-full left-0';
  // const bottom = 'top-full'
  const top = 'bottom-full transform rotate-180 translate-y-[0.5px]';
  return (
    <div className="absolute left-1/2 -bottom-2 transform -translate-x-1/2 translate-y-1/2 font-nunitoRegular font-bold text-[9.57px] text-white bg-[#5B5B5B] rounded-[3px] px-[11px] py-1.5 whitespace-nowrap hidden group-hover:block">
      <svg className={`${arrow} ${top}`} x="0px" y="0px" viewBox="0 0 255 255">
        <polygon className="fill-current" points="0,0 127.5,127.5 255,0" />
      </svg>
      <p>Coming Soon</p>
    </div>
  );
};

export default ComingSoon;
